import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInfo = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 12,
	height: 13,
	viewBox: "0 0 12 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2.06054 10.4396C1.0157 9.39475 0.428711 7.97764 0.428711 6.5C0.428711 5.02237 1.0157 3.60525 2.06054 2.56041C3.10539 1.51556 4.5225 0.928574 6.00014 0.928574C7.47777 0.928574 8.89489 1.51556 9.93973 2.56041C10.9846 3.60525 11.5716 5.02237 11.5716 6.5C11.5716 7.97764 10.9846 9.39475 9.93973 10.4396C8.89489 11.4844 7.47777 12.0714 6.00014 12.0714C4.5225 12.0714 3.10539 11.4844 2.06054 10.4396ZM6.00014 3.42857C5.75387 3.42857 5.51768 3.5264 5.34354 3.70055C5.1694 3.87469 5.07157 4.11087 5.07157 4.35714C5.07157 4.60342 5.1694 4.8396 5.34354 5.01374C5.51768 5.18788 5.75387 5.28572 6.00014 5.28572C6.24641 5.28572 6.4826 5.18788 6.65674 5.01374C6.83088 4.8396 6.92871 4.60342 6.92871 4.35714C6.92871 4.11087 6.83088 3.87469 6.65674 3.70055C6.4826 3.5264 6.24641 3.42857 6.00014 3.42857ZM6.00014 6C5.724 6 5.50014 6.22386 5.50014 6.5V9.5C5.50014 9.77614 5.724 10 6.00014 10C6.27628 10 6.50014 9.77614 6.50014 9.5V6.5C6.50014 6.22386 6.27628 6 6.00014 6Z",
		fill: "#171719"
	})]
});
const ForwardRef = forwardRef(SvgInfo);
export default ForwardRef;
